import { format } from "@hejdoktor/resx-compiler"
const pluralRules = new Intl.PluralRules("no")

export const R = {
	"AddMore": "Legg til flere",
	"BookTimeVideoCall": "Hvis du ikke har tid akkurat nå, finn en ledig tid nedenfor og bestill din videokonsultasjon. Vi sender deg en e-post med mer informasjon før samtalen.",
	"BookVideoConsultation_FirstAvailableCaregiver": "Først ledige",
	"DynamicCodeSubject": "Dynamisk kode-mottaker",
	"ErrorCreateConsultation": "Det oppstod en feil under oppsettet av konsultasjonen",
	"ErrorFetchingTimetable": "Det oppstod en feil under nedlastingsplanen. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"ErrorSchedulingConsultation": "Det oppstod en feil under planleggingen av konsultasjonen. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"ErrorSendingMessage": "Det oppstod en feil under sending av en melding. Prøv på nytt eller kontakt oss hvis problemet vedvarer.",
	"FillOutMessage": "Vennligst fyll ut en melding.",
	"InvalidFileType": "Ugyldig filtype.",
	"InvalidPayment": "Ugyldig betaling",
	"InvalidPhoneNumber": "Ugyldig telefonnummer",
	"MaxFilesExceeded": "Du kan ikke legge til flere filer.",
	"NoDoctorsAvailableForQueueScheduleMessage": "Finn en ledig time nedenfor og bestill din videokonsultasjon. Vi sender deg en e-post med mer informasjon før samtalen.",
	"PayButton": "Gå til kassen",
	"PhoneNumberRequired": "Vennligst oppgi telefonnummer. Da kan vi ta kontakt med deg hvis teknologien er et problem.",
	"PleaseAttachAnImageOfTheProblem": "Legg til et bilde som viser problemet",
	"PleaseChooseDate": "Velg dato for videokonsultasjon",
	"SendButton": "Sende",
	"SubjectRequired": "Emne obligatorisk",
	"TimeSlotUnavailable": "Tiden er dessverre allerede bestilt, vennligst velg en annen tid.",
	"TimeZoneWarning": "Tidene vises i din lokale tidssone: {0}",
	"Today": "I dag",
	"TooLateToReschedule": "Det er dessverre ikke lenger mulig å endre tidspunktet for konsultasjonen.",
	"UploadFailedTooLarge": "Filen \"{0}\" er for stor og kan derfor ikke lastes opp. Vennligst sjekk at filen din ikke er større enn 30 MB.",
	"WaitingTimeText": (number: number, { minimumFractionDigits = 0, maximumFractionDigits = 3 }: { minimumFractionDigits?: number, maximumFractionDigits?: number } = {}) => {
		const nf = new Intl.NumberFormat("no", { minimumFractionDigits, maximumFractionDigits })
		switch(pluralRules.select(number)) {
			case "one":
				return format("Det er for tiden omtrent {0} minutts ventetid.", nf.format(number))
			default:
			case "other":
				return format("Det er for tiden omtrent {0} minutts ventetid.", nf.format(number))
		}
	},
}